import { FaEye } from 'react-icons/fa';
import pdfIcon from "../../../assets/icons/pdf.svg";
import { FaRegFilePdf, FaFileExcel } from "react-icons/fa";
import { SlDocs } from "react-icons/sl";

const DocumentSection = ({ documents }) => {
  const handleView = (url) => {
    window.open(url, '_blank');
  };


  return (
    <div className="mb-4 ">
      {/* <Card className="shadow-sm"> */}
      <div className="grid grid-cols-1 gap-6">
        {Object.entries(documents || {}).map(([category, files]) => (
          <div key={category}>
            {/* <h3 className="text-lg font-medium text-gray-900 mb-4">{category}</h3> */}
            <h3 className="text-[20px] font-bold text-[#000000D9] mt-10  mb-4 text-start">{category}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {files.map((file, index) => {

                let IconComponent;
                let imageSrc;
                if (file.type === "application/pdf") {
                  // IconComponent = FaRegFilePdf;
                  imageSrc = pdfIcon
                } else if (
                  file.type ===
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ) {
                  IconComponent = FaFileExcel;
                } else {
                  IconComponent = SlDocs;
                }

                return (
                  <div
                    key={index}
                    className="flex items-center justify-between p-4 border rounded-lg hover:border-blue-400 transition-colors bg-white"
                  >
                    <div className="flex items-center gap-3">
                      {imageSrc && <img src={imageSrc} alt="PDF" className="w-8 h-8" />}
                      {IconComponent && <IconComponent className="text-3xl text-gray-500 " />}
                      <p className="text-sm font-medium text-gray-700 truncate max-w-[150px]">
                        {file.name.split('/').pop()}
                      </p>
                    </div>

                    <div className="flex gap-2">
                      <button
                        onClick={() => handleView(file.url)}
                        className="flex items-center gap-2 px-3 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
                      >
                        <FaEye className="w-4 h-4" />
                        {/* <span>View</span> */}
                      </button>
                      {/* <button
                        onClick={() => handleDownload(file.url, file.name)}
                        className="flex items-center gap-2 px-3 py-2 text-white bg-green-600 rounded-md hover:bg-green-700 transition-colors"
                      >
                        <FaDownload className="w-4 h-4" />
                        <span>Download</span>
                      </button> */}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ))}
      </div>
      {/* </Card> */}
    </div>
  );
};


export default DocumentSection;